import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_COMMON}`

const department = (form = {}) => http.put(`${api}/department/${form.id}`, form)

export default department
